import React from 'react';
import * as RadixLabel from '@radix-ui/react-label';
import { labelClass } from './inputClasses';

export default function Label({ htmlFor, required, children, className = '', ...rest }) {
  return (
    <RadixLabel.Root
      htmlFor={htmlFor}
      className={`${labelClass} ${className}`}
      {...rest}
    >
      {children}
      {required ? <span className="text-red-500 ml-0.5">*</span> : null}
    </RadixLabel.Root>
  );
}
